import { render, staticRenderFns } from "./item-checkbox.vue?vue&type=template&id=3486716e&scoped=true"
import script from "./item-checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./item-checkbox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-checkbox.vue?vue&type=style&index=0&id=3486716e&prod&lang=less&scoped=true"
import style1 from "./item-checkbox.vue?vue&type=style&index=1&id=3486716e&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3486716e",
  null
  
)

export default component.exports